import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LogService } from '../log/log.service';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

  constructor(private router: Router,
              private authService: AuthenticationStore,
              private logService: LogService,
              private environment: EnvironmentConfiguration) {
  }

  canActivate(): Observable<boolean> {
    return this.authService.isLoggedIn().map(isLoggedIn => {
      if (!isLoggedIn) {
        this.router.navigate([this.environment.logout], { queryParams: { 'redirect': true }} );
      }
      return isLoggedIn;
    });
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/can-activate-via-auth-guard.ts